export default "__VITE_ASSET__Xj8oDL5C__"